export function generateKeywords(inputText) {
  let inputString = inputText.toLowerCase();
  let keywords = [];

  // Split all words
  const words = inputString.split(" ");

  // For each word
  for (const word of words) {
    let appendString = "";

    // For every character
    for (let charPosition = 0; charPosition < inputString.length; charPosition++) {
      appendString += inputString[charPosition];
      keywords.push(appendString);
    }

    // Remove the first word
    inputString = inputString.replace(`${word} `, "");
  }

  return keywords;
}

export function formatTimestamp (timestamp)  {
  if (!timestamp) return "Not available";

  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  return timestamp.toLocaleDateString("en-US", options);
};